import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-26010d14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "btn" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "notification-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, onMounted } from 'vue'
import AgendaService from '@/services/AgendaService'
import { useRoute } from 'vue-router';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'AgendaDetail',
  setup(__props) {

const route =  useRoute()
const service = new AgendaService()
const quote:any = ref([])
const loading = ref(false)

onMounted(async()=>{
    loading.value = true
    quote.value = await service.GetQuoteDetails(route.params.id)
    loading.value = false
})


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: { name: 'agenda'} ,
            style: {"color":"white","text-decoration":"none","font-weight":"bold"}
          }, {
            default: _withCtx(() => [
              _createTextVNode("Volver")
            ]),
            _: 1
          })
        ]),
        _hoisted_3,
        _createElementVNode("h1", {
          style: _normalizeStyle({'color' : _unref(main).SECONDARY_COLOR })
        }, _toDisplayString(quote.value.title), 5),
        _hoisted_4,
        _createElementVNode("h3", {
          style: _normalizeStyle({'color' : _unref(main).SECONDARY_COLOR })
        }, "Fecha y hora :", 4),
        _hoisted_5,
        (quote.value.date)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(quote.value.date.slice(0,16)), 1))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createElementVNode("h3", {
          style: _normalizeStyle({'color' : _unref(main).SECONDARY_COLOR })
        }, "Detalles :", 4),
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, _toDisplayString(quote.value.description), 1),
        _hoisted_10
      ])
    ]),
    _: 1
  }))
}
}

})